import { useId, type ReactNode } from 'react';
import { Seg } from './Seg';
import './choice-tiles.css';

/** Общий выбор одного значения; значения принадлежат продуктовому экрану. */
export function ChoiceTiles({
  label,
  choices,
  value,
  disabled,
  onChange,
  variant = 'segments',
}: {
  label: string;
  choices: Array<{ value: string; label: string; description?: string; icon?: ReactNode }>;
  variant?: 'segments' | 'rows';
  value: string;
  disabled?: boolean;
  onChange(value: string): void;
}) {
  const id = useId();
  return (
    <fieldset className="studio-choice-tiles" aria-labelledby={id}>
      <legend id={id}>{label}</legend>
      {variant === 'rows' ? (
        <div role="radiogroup" aria-label={label}>
          {choices.map(choice => (
            <button
              key={choice.value}
              type="button"
              role="radio"
              aria-checked={choice.value === value}
              disabled={disabled}
              className={`sc-r${choice.value === value ? ' on' : ''}`}
              onClick={() => onChange(choice.value)}
            >
              {choice.icon && (
                <span className="sc-th" aria-hidden="true">
                  {choice.icon}
                </span>
              )}
              <span className="m">
                <b>{choice.label}</b>
                {choice.description && <small>{choice.description}</small>}
              </span>
              <span className="rd" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="m5 12 4 4L19 6" />
                </svg>
              </span>
            </button>
          ))}
        </div>
      ) : (
        <Seg
          items={choices.map(choice => ({ key: choice.value, label: choice.label, disabled }))}
          value={value}
          onChange={onChange}
          label={label}
          role="radiogroup"
          aria="aria-checked"
        />
      )}
    </fieldset>
  );
}
